// import store from '@/store'
import ModuleBase from '../components/ModuleBase'
import Dashboard from '../views/dashboard/Dashboard'
import Overview from '../views/entry/Overview'

const routes = [
  {
    path: '/timesheets/',
    component: ModuleBase,
    meta: { appKey: 'timesheets' },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'TimesheetsDashboard'
      },
      {
        path: 'entry/:id',
        component: Overview,
        name: 'TimesheetEntry'
      }
    ]
  }
]

export default routes
